import { useMemo } from 'react';

/**
 * Hook personalizado para validación de fechas dinámicas
 * Calcula minDate y maxDate basado en la fecha actual
 * Validación: fecha válida ≥ hoy − 12 meses y ≤ hoy + 18 meses
 */
export const useDateValidation = () => {
  const { minDate, maxDate } = useMemo(() => {
    const today = new Date();
    const min = new Date(today);
    min.setMonth(today.getMonth() - 12);
    const max = new Date(today);
    max.setMonth(today.getMonth() + 18);
    return {
      minDate: min.toISOString().split('T')[0],
      maxDate: max.toISOString().split('T')[0],
    };
  }, []);

  return { minDate, maxDate };
};
